module.exports = __webpack_public_path__ + "static/artificial-intelligence-b15f25bf5af21e5e3db4e92b21548e08.svg";